<template>
<div class="chapter">
<div class="inner_page">
<h1 class="bktit1"><a id="page_ii"></a><a id="page_iii"></a>Royal Mysteries of the Anglo-Saxons and Early Britain</h1>
<p class="author">Timothy Venning</p>
<div class="img_containerp">
<img alt="Images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?273bae58